import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { LoginByTokenAction } from "../redux/actions/user-action-types";

const LoginShare = () => {
	let { token } = useParams();
	debugger;
	const dispatch = useDispatch();
	React.useEffect(() => {
		if (token?.length > 0) {
			dispatch(
				LoginByTokenAction({
					token,
					callback: () => {
						setTimeout(() => {
							window.location.href("/exam-ref-list");
						}, 1500);
					},
				}),
			);
		} else {
		}
	}, [token, dispatch]);

	return <div style={{ display: "flex", height: "100%" }}>LOADING</div>;
};

export default LoginShare;
